import type { Site } from '@/types/site';

interface InvestmentDetailTabProps {
  site: Site;
}

export default function InvestmentDetailTab({
  site,
}: Readonly<InvestmentDetailTabProps>) {
  return (
    <div className="space-y-6">
      <div className="bg-gray-50 rounded-xl p-6">
        <h4 className="text-lg font-semibold text-gray-900 mb-4">투자 정보</h4>
        {site.investmentInfos && site.investmentInfos.length > 0 ? (
          <div className="space-y-6">
            {site.investmentInfos.map((investment, index) => (
              <div key={index} className="bg-white rounded-lg p-6 border">
                <h5 className="font-semibold text-gray-900 mb-4">
                  투자 정보 {index + 1}
                </h5>

                {/* 기본 정보 */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  {investment.type && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">투자 유형:</span>
                      <span className="text-gray-900">{investment.type}</span>
                    </div>
                  )}
                  {investment.contractor && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">시공업체:</span>
                      <span className="text-gray-900">
                        {investment.contractor}
                      </span>
                    </div>
                  )}
                  {investment.constructDate && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">시공일자:</span>
                      <span className="text-gray-900">
                        {investment.constructDate}
                      </span>
                    </div>
                  )}
                </div>

                {/* 투자비용 정보 */}
                <div className="border-t pt-4">
                  <h6 className="font-medium text-gray-900 mb-3">
                    투자비용 내역
                  </h6>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                    {investment.countryCost && (
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <span className="text-gray-600 text-xs">국비</span>
                        <p className="font-semibold text-gray-900">
                          {investment.countryCost.toLocaleString()}원
                        </p>
                      </div>
                    )}
                    {investment.provinceCost && (
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <span className="text-gray-600 text-xs">도비</span>
                        <p className="font-semibold text-gray-900">
                          {investment.provinceCost.toLocaleString()}원
                        </p>
                      </div>
                    )}
                    {investment.cityCost && (
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <span className="text-gray-600 text-xs">시비</span>
                        <p className="font-semibold text-gray-900">
                          {investment.cityCost.toLocaleString()}원
                        </p>
                      </div>
                    )}
                    {investment.citizenCost && (
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <span className="text-gray-600 text-xs">
                          주민부담금
                        </span>
                        <p className="font-semibold text-gray-900">
                          {investment.citizenCost.toLocaleString()}원
                        </p>
                      </div>
                    )}
                    {investment.etcCost && (
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <span className="text-gray-600 text-xs">기타비용</span>
                        <p className="font-semibold text-gray-900">
                          {investment.etcCost.toLocaleString()}원
                        </p>
                      </div>
                    )}
                    {/* 총 투자비용 */}
                    <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                      <span className="text-blue-600 text-xs">총 투자비용</span>
                      <p className="font-bold text-blue-900">
                        {(
                          (investment.countryCost || 0) +
                          (investment.provinceCost || 0) +
                          (investment.cityCost || 0) +
                          (investment.citizenCost || 0) +
                          (investment.etcCost || 0)
                        ).toLocaleString()}
                        원
                      </p>
                    </div>
                  </div>
                </div>

                {/* 비고 */}
                {investment.explanatoryNote && (
                  <div className="border-t pt-4 mt-4">
                    <span className="text-gray-600 text-xs">비고:</span>
                    <p className="text-gray-900 text-sm mt-1">
                      {investment.explanatoryNote}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <i className="ri-funds-line text-4xl text-gray-400 mb-2"></i>
            <p className="text-gray-500">등록된 투자 정보가 없습니다.</p>
          </div>
        )}
      </div>
    </div>
  );
}
